import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { PromoProductFamilyProduct } from './promo-product-family-partner.entity';

export class PromoProductFamily extends BaseEntity {
  
  promoProductFamilyCode        : string;
  name                          : string;
  rank                          : number;
  
  promoProductFamilyProducts    : PromoProductFamilyProduct[];

  constructor() {
    super()
  }

}
